import * as React from "react"
import { Flex, HStack, Heading, Text, Select } from "@chakra-ui/react"

import { TOPBAR_HEIGHT } from "../lib/config"
import { ZONE_TYPE_OPTIONS } from "../lib/static/zone"
import { ZoneType } from "../lib/types/zone"

interface Props {
  type: ZoneType
  setType: (type: ZoneType) => void
}

export const ZonesTopbar = (props: Props) => {
  return (
    <Flex align="center" justify="space-between" p={6} h={TOPBAR_HEIGHT}>
      <Heading as="h3" color="gray.700">
        Zones
      </Heading>
      <HStack spacing={4}>
        <HStack spacing={2} align="center">
          <Text>Zone type:</Text>
          <Select
            w="200px"
            onChange={(e) => props.setType(e.target.value as ZoneType)}
            defaultValue={props.type}
          >
            {ZONE_TYPE_OPTIONS.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </HStack>
      </HStack>
    </Flex>
  )
}
